import { ACTIVITY_TYPE } from 'common/constants';
import { getFormatedDateRange } from 'common/utils/utilFunctions';

const {
	TODAY,
	THIS_WEEK,
	THIS_MONTH,
	LAST_3_MONTH,
	LAST_6_MONTH,
	THIS_YEAR,
	DATE_RANGE,
	CLEAR_ALL,
} = ACTIVITY_TYPE;
export enum HORIZON_PROGRESS_BAR_ELEMENTS {
	NOTSTARTED = 'Not Started',
	APPLICABILITY_ASSESSMENT = 'Applicability Assessment',
	IMPACT_ANALYSIS = 'Impact Analysis',
	ACTION_PLAN = 'Action Plan',
	COMPLIANCE_ACCEPTANCE = 'Compliance Acceptance',
	COMPLETE = 'Complete',
}

export enum HORIZON_EXPORT_COLUMNS {
	CREATED_BY = 'createdDate',
	AI_SUMMARY = 'aiSummary',
	JURISDICTION = 'jurisdiction',
	LINK_URL = 'linkURL',
	LAST_REVISION_DATE = 'reviewByDate',
	ONTOLOGY = 'ontology',
	TITLE = 'title',
	TYPE = 'type',
	REGULATORS = 'regulators',
	EFFECTIVE_DATE = 'effectiveDate',
}
export enum HORIZON_APPLICABILITY_DROPDOWN_LABEL {
	APPLICABILITY = 'Applicability',
	IDENTIFY_CHANGE = 'Identify Change',
}
export enum HORIZON_APPLICABILITY_STATUS {
	APPLICABLE = 'Applicable',
	NOTAPPLICABLE = 'Not Applicable',
	POTENTIALLY_ACTIONABLE = 'Potentially Actionable',
	INFORMATIONAL = 'Informational',
	IGNORE = 'Ignore',
}

export const regHeaders = [
	{
		name: 'Issuing Body',
		key: 'regulators',
	},
	{
		name: 'Issuance Type',
		key: 'type',
	},
	{
		name: 'Assigned to',
		key: 'assignedUserName',
	},
	{
		name: 'Effective Date',
		key: 'effectiveDate',
	},
	{
		name: 'Due Date',
		key: 'dueDate',
	},
];

export const getHorizonProgressBarElements = [
	{
		index: 0,
		value: 2.5,
		label: HORIZON_PROGRESS_BAR_ELEMENTS.NOTSTARTED,
	},
	{
		index: 1,
		value: 22,
		label: HORIZON_PROGRESS_BAR_ELEMENTS.APPLICABILITY_ASSESSMENT,
	},
	{
		index: 2,
		value: 42,
		label: HORIZON_PROGRESS_BAR_ELEMENTS.IMPACT_ANALYSIS,
	},
	{
		index: 3,
		value: 62,
		label: HORIZON_PROGRESS_BAR_ELEMENTS.ACTION_PLAN,
	},
	{
		index: 4,
		value: 82,
		label: HORIZON_PROGRESS_BAR_ELEMENTS.COMPLIANCE_ACCEPTANCE,
	},
	{
		index: 5,
		value: 98,
		label: HORIZON_PROGRESS_BAR_ELEMENTS.COMPLETE,
	},
];

export const horizonComplianceMsg =
	'I understand that the horizon scanning updates were reviewed and once marked as complete only Owner will be able to update/edit';

export const DATE_ENTITY = {
	DUE_DATE: 'reviewByDate',
	EFFECTIVE_DATE: 'effectiveDate',
	MODIFIED_DATE: 'modifiedDate',
};

export const DATE_DURATION = {
	CUSTOM_DATES: 'Custom dates',
	ALL: 'All',
	THIS_WEEK: 'This week',
	THIS_MONTH: 'This month',
	LAST_THREE_MONTHS: 'Last 3 months',
	LAST_SIX_MONTHS: 'Last 6 months',
	THIS_YEAR: 'This year',
};
export const DATE_RANGE_MODEL_CONSTANTS = {
	HEADING: 'Set date range',
	APPLY: 'Apply',
	CANCEL: 'Cancel',
};

export const activityDropdownOptions = [
	{
		label: TODAY,
		value: getFormatedDateRange(TODAY),
	},
	{
		label: THIS_WEEK,
		value: getFormatedDateRange(THIS_WEEK),
	},
	{
		label: THIS_MONTH,
		value: getFormatedDateRange(THIS_MONTH),
	},
	{
		label: LAST_3_MONTH,
		value: getFormatedDateRange(LAST_3_MONTH),
	},
	{
		label: LAST_6_MONTH,
		value: getFormatedDateRange(LAST_6_MONTH),
	},
	{
		label: THIS_YEAR,
		value: getFormatedDateRange(THIS_YEAR),
	},
	{
		label: DATE_RANGE,
		value: DATE_RANGE,
	},
	{
		label: CLEAR_ALL,
		value: CLEAR_ALL,
	},
];
export const TITLE_LENGTH = 100;
